import { selectIsAppInitialized } from '@/shared/redux'
import { LogoAnimated } from '@/shared/ui'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import './SplashScreen.scss'

export const SplashScreen = () => {
  const isInitialized = useSelector(selectIsAppInitialized)
  const [shouldRender, setShouldRender] = useState(true)
  const [isFadingOut, setIsFadingOut] = useState(false)
  const mountTimeRef = useRef(Date.now())

  useEffect(() => {
    // Logo animation finishes drawing at ~1.3s; hold ~0.7s after that before fading out
    const minTime = 2000

    let fadeTimer: NodeJS.Timeout
    let unmountTimer: NodeJS.Timeout

    if (isInitialized) {
      const elapsed = Date.now() - mountTimeRef.current
      const remainingDelay = Math.max(0, minTime - elapsed)

      fadeTimer = setTimeout(() => {
        setIsFadingOut(true)
        unmountTimer = setTimeout(() => {
          setShouldRender(false)
        }, 600) // Matches CSS transition duration
      }, remainingDelay)
    }

    return () => {
      clearTimeout(fadeTimer)
      clearTimeout(unmountTimer)
    }
  }, [isInitialized])

  if (!shouldRender) return null

  return (
    <div className={`splash-screen ${isFadingOut ? 'splash-screen--fade-out' : ''}`}>
      <div className="splash-screen__backdrop-glow" />
      <div className="splash-screen__logo-container">
        <LogoAnimated className="splash-screen__svg" />
      </div>
    </div>
  )
}

export default SplashScreen
